module.exports = __webpack_public_path__ + "static/img/t1-1-2.20000c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/t1-1-2.png
// module id = eO2W
// module chunks = 1